import { Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useBulkSaveMemberMasterMasterMutation, useFindAllMemberMasterMasterMutation, useGetMemberMasterByIdMutation, useSaveMemberMasterMutation, useUpdateMemberMasterMutation } from "../../redux-toolkit/services/MemberMasterService";
import { useBulkSaveMemberCategoryMasterMasterMutation, useFindAllMemberCategoryMasterMasterMutation, useGetMemberCategoryMasterByIdMutation, useSaveMemberCategoryMasterMutation, useUpdateMemberCategoryMasterMutation } from "../../redux-toolkit/services/MemberCategoryMasterService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getMemberMasterList, setMemberMasterList } from "../../redux-toolkit/slices/memberMasterSlice";
import { getMemberCategoryMasterList, setAllMemberCategoryMaster } from "../../redux-toolkit/slices/memberCategoryMasterSlice";
import { useBulkSaveAccountCategoryMutation, useGetAccountCategoryByIdMutation, useGetAllAccountCategoryMutation, useSaveAccountCategoryMutation, useUpdateAccountCategoryMutation } from "../../redux-toolkit/services/acountCategoryMasterServices";
import { useBulkSaveAccountMutation, useGetAccountByIdMutation, useSaveAccountMutation, useUpdateAccountMutation } from "../../redux-toolkit/services/accountMasterService";
import { getAllAccountCategoryMasterList, setAllAccountCategoryMaster } from "../../redux-toolkit/slices/accountCategoryMasterSlice";
import { useBulkUploadScenarioMastersMutation, useGetScenarioMasterByIdMutation, useSaveScenarioMasterMutation, useUpdateScenarioMasterMutation } from "../../redux-toolkit/services/scenarioMasterService";
import { useBulkUploadScripturalReferencesMutation, useGetScripturalReferenceByIdMutation, useSaveScripturalReferenceMutation, useUpdateScripturalReferenceMutation } from "../../redux-toolkit/services/scripturalReferenceMasterService";
import { useFindAllOrganizationMasterMutation } from "../../redux-toolkit/services/organizationMasterService";
import { allOrganizationMasterDetails, setAllOrganizationMaster } from "../../redux-toolkit/slices/organizationMasterSlice";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useBulkSaveAuditLogMutation, useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";
import { useBulkSaveAccountTypeMasterMutation, useFindAllAccountTypeMasterMutation, useGetAccountTypeMasterByIdMutation, useSaveAccountTypeMasterMutation, useUpdateAccountTypeMasterMutation } from "../../redux-toolkit/services/accountTypeMasterService";
import { getAccountTypeMasterList, setAllAccountTypeMaster } from "../../redux-toolkit/slices/accountTypeMasterSlice";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};



const MemberAccountingReportData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    console.log(getByIdData, "getByIdData");
    const [file, setFile]: any = useState<File | null>(null);
    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");

    //save
    const [saveMemberMaster, saveMemberMasterResponse] = useSaveMemberMasterMutation();
    const [saveScenarioMaster, saveScenarioMasterResponse] = useSaveScenarioMasterMutation();
    const [saveMemberCategoryMaster, saveMemberCategoryMasterResponse] = useSaveMemberCategoryMasterMutation();
    const [saveAccountMaster, saveAccountMasterResponse] = useSaveAccountMutation();
    const [saveAccountCategoryMaster, saveAccountCategoryMasterResponse] = useSaveAccountCategoryMutation();
    const [saveScripturalReferenceMaster, saveScripturalReferenceMasterResponse] = useSaveScripturalReferenceMutation();
    const [saveAccountTypeMaster, saveAccountTypeMasterResponse] = useSaveAccountTypeMasterMutation();
    const [logAudit] = useSaveAuditLogMutation();
    const [logAuditBulk] = useBulkSaveAuditLogMutation();

    const [bulkSaveMemberMaster, bulkSaveMemberMasterResponse] = useBulkSaveMemberMasterMasterMutation();
    const [bulkSaveMemberCategoryMaster, bulkSaveMemberCategoryMasterResponse] = useBulkSaveMemberCategoryMasterMasterMutation();
    const [bulkSaveAccountMaster, bulkSaveAccountMasterResponse] = useBulkSaveAccountMutation();
    const [bulkSaveAccountCategoryMaster, bulkSaveAccountCategoryMasterResponse] = useBulkSaveAccountCategoryMutation();
    const [bulkSaveScenarioMasters, bulkSaveScenarioMastersResponse] = useBulkUploadScenarioMastersMutation();
    const [bulkSaveScripturalReferencesMasters, bulkSaveScripturalReferencesMastersResponse] = useBulkUploadScripturalReferencesMutation();
    const [bulkSaveAccountTypeMasterMasters, bulkSaveAccountTypeMasterMastersResponse] = useBulkSaveAccountTypeMasterMutation();
    //update
    const [updateMemberMaster, updateMemberMasterResponse] = useUpdateMemberMasterMutation();
    const [updateMemberCategoryMaster, updateMemberCategoryMasterResponse] = useUpdateMemberCategoryMasterMutation();
    const [updateAccountMaster, updateAccountMasterResponse] = useUpdateAccountMutation();
    const [updateAccountCategoryMaster, updateAccountCategoryMasterResponse] = useUpdateAccountCategoryMutation();
    const [updateScenarioMaster, updateScenarioMasterResponse] = useUpdateScenarioMasterMutation();
    const [updateScripturalReferenceMaster, updateScripturalReferenceMasterResponse] = useUpdateScripturalReferenceMutation();
    const [updateAccountTypeMasterMaster, updateAccountTypeMasterMasterResponse] = useUpdateAccountTypeMasterMutation();

    //getById mutation
    const [getMemberMasterById, memberMasterByIdResponse] = useGetMemberMasterByIdMutation();
    const [getMemberCategoryMasterById, memberCategoryMasterByIdResponse] = useGetMemberCategoryMasterByIdMutation();
    const [getAccountMasterById, accountMasterByIdResponse] = useGetAccountByIdMutation();
    const [getAccountCategoryMasterById, accountCategoryMasterByIdResponse] = useGetAccountCategoryByIdMutation();
    const [getScenarioMasterById, scenarioMasterByIdResponse] = useGetScenarioMasterByIdMutation();
    const [getScripturalReferenceMasterById, scripturalReferenceMasterByIdResponse] = useGetScripturalReferenceByIdMutation();
    const [getAccountTypeMasterById, accountTypeMasterByIdResponse] = useGetAccountTypeMasterByIdMutation();
    //getData
    const [getAllMemberCategories, allMemberCategoriesResponse] = useFindAllMemberCategoryMasterMasterMutation();
    const [getAllAccountCategories, allAccountCategoriesResponse] = useGetAllAccountCategoryMutation();
    const [getAllMemberMaster, getAllMemberMasterResponse] = useFindAllMemberMasterMasterMutation();
    const [getAllOrganizationMasterMaster, getAllOrganizationMasterResponse] = useFindAllOrganizationMasterMutation();
    const [getAllAccountTypeMaster, getAllAccountTypeMasterResponse] = useFindAllAccountTypeMasterMutation();
    //Data
    const allMemberCategoriesData: any = useAppSelector(getMemberCategoryMasterList);
    const allAccountCategoriesData: any = useAppSelector(getAllAccountCategoryMasterList);
    const allMemberMastersData: any = useAppSelector(getMemberMasterList);
    const allOrganizationMasterData: any = useAppSelector(allOrganizationMasterDetails);
    const allAccountTypeMasterData: any = useAppSelector(getAccountTypeMasterList);


    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.MEMBER_MASTER) {
                getMemberMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllMemberMaster({ token: localUserObj?.token })
                getAllOrganizationMasterMaster({ token: localUserObj?.token })
                getAllMemberCategories({ token: localUserObj?.token });
            } else if (props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
                getMemberCategoryMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_MASTER) {
                getAccountMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllAccountCategories({
                    token: localUserObj?.token
                })
            } else if (props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
                getAccountCategoryMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllAccountTypeMaster({
                    token: localUserObj?.token
                })
            } else if (props.reportName === REPORT_NAME.SCENARIO_MASTER) {
                getScenarioMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                getAllMemberMaster({ token: localUserObj?.token })
            }
            else if (props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
                getScripturalReferenceMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });

            }
            else if (props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                getAccountTypeMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.MEMBER_MASTER) {
                getAllMemberCategories({});
                getAllMemberMaster({ token: localUserObj?.token })
                getAllOrganizationMasterMaster({ token: localUserObj?.token })
            } else if (props.reportName === REPORT_NAME.ACCOUNT_MASTER) {
                getAllAccountCategories({
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
                getAllAccountTypeMaster({
                    token: localUserObj?.token
                })
            }
            else if (props.reportName === REPORT_NAME.SCENARIO_MASTER) {
                getAllMemberMaster({ token: localUserObj?.token })
            }
            else if (props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                getAllAccountTypeMaster({
                    token: localUserObj?.token
                })

            }
        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };


    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.MEMBER_MASTER) {

                const payload = {
                    isActive: true,
                    memberName: values.memberName,
                    memberCategoryCode: values.memberName,
                    orgCode: values.orgCode,
                    gender: values.gender,
                    dob: values.dob,
                    contactInfo: values.contactInfo,
                    dependentMemberId: values.dependentMemberId,
                }

                saveMemberMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {

                const payload = {
                    isActive: true,
                    memberCategoryName: values.memberCategoryName,
                    description: values.description,
                }

                saveMemberCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_MASTER) {

                const payload = {
                    isActive: true,
                    accountName: values.accountName,
                    accountCategoryCode: values.accountCategoryCode,
                    description: values.description,
                    dependentAccountCode: values.dependentAccountCode,
                }

                saveAccountMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {

                const payload = {
                    isActive: true,
                    accountCategoryName: values.accountCategoryName,
                    accountTypeId: values.accountTypeId,
                    description: values.description,
                    dependentAccountCategoryCode: values.dependentAccountCategoryCode,
                }

                saveAccountCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

            else if (props.reportName === REPORT_NAME.SCENARIO_MASTER) {
                const payload = {
                    memberId: values.memberId,
                    scenarioType: values.scenarioType,
                    description: values.description,
                    religion: values.religion,
                    projectTag: values.projectTag,
                    intensityLevel: values.intensityLevel,
                    isActive: true,
                }

                saveScenarioMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
            else if (props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
                const payload = {
                    religion: values.religion,
                    textSnippet: values.textSnippet,
                    context: values.context,
                    application: values.application,
                    isActive: true,
                };

                saveScripturalReferenceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

            else if (props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                const payload = {
                    accountCode: values.accountTypeCode,
                    accountName: values.accountTypeName,
                    accountDescription: values.accountTypeDescription,
                    isActive: values.isActive ?? true,
                };


                saveAccountTypeMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }


        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.MEMBER_MASTER) {

                const payload = {
                    isActive: props.data.isActive,
                    id: props?.data?.id,
                    memberName: values.memberName,
                    memberCategoryCode: values.memberCategoryCode,
                    orgCode: values.orgCode,
                    gender: values.gender,
                    dob: values.dob,
                    contactInfo: values.contactInfo,
                    dependentMemberId: values.dependentMemberId,
                }
                updateMemberMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {

                const payload = {
                    isActive: props.data.isActive,
                    id: props?.data?.id,
                    memberCategoryName: values.memberCategoryName,
                    description: values.description,
                }

                updateMemberCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_MASTER) {

                const payload = {
                    isActive: props.data.isActive,
                    id: props?.data?.id,
                    accountName: values.accountName,
                    accountCategoryCode: values.accountCategoryCode,
                    description: values.description,
                    dependentAccountCode: values.dependentAccountCode,
                }

                updateAccountMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {

                const payload = {
                    isActive: props.data.isActive,
                    id: props?.data?.id,
                    accountCategoryName: values.accountCategoryName,
                    accountTypeId: values.accountTypeId,
                    description: values.description,
                    dependentAccountCategoryCode: values.dependentAccountCategoryCode,
                }

                updateAccountCategoryMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.SCENARIO_MASTER) {
                const payload = {
                    id: props?.data?.id,
                    memberId: values.memberId,
                    scenarioType: values.scenarioType,
                    description: values.description,
                    religion: values.religion,
                    projectTag: values.projectTag,
                    intensityLevel: values.intensityLevel,
                    isActive: true,
                }
                updateScenarioMaster({
                    id: props?.data?.id,
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
                const payload = {
                    id: props?.data?.id,
                    religion: values.religion,
                    textSnippet: values.textSnippet,
                    context: values.context,
                    application: values.application,
                    isActive: true,
                };

                updateScripturalReferenceMaster({
                    id: props?.data?.id,
                    token: localUserObj?.token,
                    payload: payload,
                });
            }
            else if (props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                const payload = {
                    id: values.id,
                    accountCode: values.accountTypeCode,
                    accountName: values.accountTypeName,
                    accountDescription: values.accountTypeDescription,
                    isActive: values.isActive ?? true,
                };
                updateAccountTypeMasterMaster({
                    id: values.id,
                    token: localUserObj?.token,
                    payload: payload,
                });
            }


        }
    };

    //save member master
    useEffect(() => {
        if (saveMemberMasterResponse.isSuccess) {
            const response: any = saveMemberMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.MEMBER_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Member Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveMemberMasterResponse.isError) {
            let response: any = saveMemberMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveMemberMasterResponse.isSuccess, saveMemberMasterResponse.isError]);

    //save member category master
    useEffect(() => {
        if (saveMemberCategoryMasterResponse.isSuccess) {
            const response: any = saveMemberCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.MEMBER_CATEGORY_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Member Category Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveMemberCategoryMasterResponse.isError) {
            let response: any = saveMemberCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveMemberCategoryMasterResponse.isSuccess, saveMemberCategoryMasterResponse.isError]);


    useEffect(() => {
        if (saveScripturalReferenceMasterResponse.isSuccess) {
            const response: any = saveScripturalReferenceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Scriptural Reference Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveScripturalReferenceMasterResponse.isError) {
            let response: any = saveScripturalReferenceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveScripturalReferenceMasterResponse.isSuccess, saveScripturalReferenceMasterResponse.isError]);


    useEffect(() => {
        if (saveAccountTypeMasterResponse.isSuccess) {
            const response: any = saveAccountTypeMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.ACCOUNT_TYPE_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Account Type Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAccountTypeMasterResponse.isError) {
            let response: any = saveAccountTypeMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAccountTypeMasterResponse.isSuccess, saveAccountTypeMasterResponse.isError]);



    //update member master
    useEffect(() => {
        if (updateMemberMasterResponse.isSuccess) {
            const response: any = updateMemberMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.MEMBER_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: memberMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Member Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateMemberMasterResponse.isError) {
            let response: any = updateMemberMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateMemberMasterResponse.isSuccess, updateMemberMasterResponse.isError]);

    //update member category master
    useEffect(() => {
        if (updateMemberCategoryMasterResponse.isSuccess) {
            const response: any = updateMemberCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.MEMBER_CATEGORY_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: memberCategoryMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Member Category updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateMemberCategoryMasterResponse.isError) {
            let response: any = updateMemberCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateMemberCategoryMasterResponse.isSuccess, updateMemberCategoryMasterResponse.isError]);


    useEffect(() => {
        if (updateScripturalReferenceMasterResponse.isSuccess) {
            const response: any = updateScripturalReferenceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: scripturalReferenceMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Scriptural Reference Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateScripturalReferenceMasterResponse.isError) {
            let response: any = updateScripturalReferenceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateScripturalReferenceMasterResponse.isSuccess, updateScripturalReferenceMasterResponse.isError]);


    useEffect(() => {
        if (updateAccountTypeMasterMasterResponse.isSuccess) {
            const response: any = updateAccountTypeMasterMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.ACCOUNT_TYPE_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: updateAccountTypeMasterMasterResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Account Type Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAccountTypeMasterMasterResponse.isError) {
            let response: any = updateAccountTypeMasterMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAccountTypeMasterMasterResponse.isSuccess, updateAccountTypeMasterMasterResponse.isError]);



    useEffect(() => {
        if (memberMasterByIdResponse.isSuccess) {
            setGetByIdData(memberMasterByIdResponse.data);
        } else if (memberMasterByIdResponse.isError) {
            let response: any = memberMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [memberMasterByIdResponse.isSuccess, memberMasterByIdResponse.isError]);

    useEffect(() => {
        if (memberCategoryMasterByIdResponse.isSuccess) {
            setGetByIdData(memberCategoryMasterByIdResponse.data);
        } else if (memberCategoryMasterByIdResponse.isError) {
            let response: any = memberCategoryMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [memberCategoryMasterByIdResponse.isSuccess, memberCategoryMasterByIdResponse.isError]);

    useEffect(() => {
        if (allMemberCategoriesResponse.isSuccess) {
            dispatch(setAllMemberCategoryMaster(allMemberCategoriesResponse));
        } else if (allMemberCategoriesResponse.isError) {
            let response: any = allMemberCategoriesResponse.error;
            alertMessage(response, "error");
        }
    }, [allMemberCategoriesResponse.isSuccess, allMemberCategoriesResponse.isError]);



    //save account master
    useEffect(() => {
        if (saveAccountMasterResponse.isSuccess) {
            const response: any = saveAccountMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Account Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAccountMasterResponse.isError) {
            let response: any = saveAccountMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAccountMasterResponse.isSuccess, saveAccountMasterResponse.isError]);

    //save account category master
    useEffect(() => {
        if (saveAccountCategoryMasterResponse.isSuccess) {
            const response: any = saveAccountCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Account Category Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAccountCategoryMasterResponse.isError) {
            let response: any = saveAccountCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAccountCategoryMasterResponse.isSuccess, saveAccountCategoryMasterResponse.isError]);



    useEffect(() => {
        if (saveScenarioMasterResponse.isSuccess) {
            const response: any = saveScenarioMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Scenario Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveScenarioMasterResponse.isError) {
            let response: any = saveScenarioMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveScenarioMasterResponse.isSuccess, saveScenarioMasterResponse.isError]);


    //update account master
    useEffect(() => {
        if (updateAccountMasterResponse.isSuccess) {
            const response: any = updateAccountMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: accountMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Account Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAccountMasterResponse.isError) {
            let response: any = updateAccountMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAccountMasterResponse.isSuccess, updateAccountMasterResponse.isError]);

    useEffect(() => {
        if (updateAccountCategoryMasterResponse.isSuccess) {
            const response: any = updateAccountCategoryMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: accountTypeMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Account Category updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAccountCategoryMasterResponse.isError) {
            let response: any = updateAccountCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAccountCategoryMasterResponse.isSuccess, updateAccountCategoryMasterResponse.isError]);


    useEffect(() => {
        if (updateScenarioMasterResponse.isSuccess) {
            const response: any = updateScenarioMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.VOUCHER_TYPE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: scenarioMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
            alertMessage("Scenario updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateScenarioMasterResponse.isError) {
            let response: any = updateScenarioMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateScenarioMasterResponse.isSuccess, updateScenarioMasterResponse.isError]);


    useEffect(() => {
        if (accountMasterByIdResponse.isSuccess) {
            setGetByIdData(accountMasterByIdResponse.data);
        } else if (accountMasterByIdResponse.isError) {
            let response: any = accountMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [accountMasterByIdResponse.isSuccess, accountMasterByIdResponse.isError]);

    useEffect(() => {
        if (accountCategoryMasterByIdResponse.isSuccess) {
            setGetByIdData(accountCategoryMasterByIdResponse.data);
        } else if (accountCategoryMasterByIdResponse.isError) {
            let response: any = accountCategoryMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [accountCategoryMasterByIdResponse.isSuccess, accountCategoryMasterByIdResponse.isError]);

    useEffect(() => {
        if (scenarioMasterByIdResponse.isSuccess) {
            setGetByIdData(scenarioMasterByIdResponse.data);
        } else if (scenarioMasterByIdResponse.isError) {
            let response: any = scenarioMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [scenarioMasterByIdResponse.isSuccess, scenarioMasterByIdResponse.isError]);



    useEffect(() => {
        if (scripturalReferenceMasterByIdResponse.isSuccess) {
            setGetByIdData(scripturalReferenceMasterByIdResponse.data);
        } else if (scripturalReferenceMasterByIdResponse.isError) {
            let response: any = scripturalReferenceMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [scripturalReferenceMasterByIdResponse.isSuccess, scripturalReferenceMasterByIdResponse.isError]);

    useEffect(() => {
        if (accountTypeMasterByIdResponse.isSuccess) {
            setGetByIdData(accountTypeMasterByIdResponse.data);
        } else if (accountTypeMasterByIdResponse.isError) {
            let response: any = accountTypeMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [accountTypeMasterByIdResponse.isSuccess, accountTypeMasterByIdResponse.isError]);



    useEffect(() => {
        if (allAccountCategoriesResponse.isSuccess) {
            dispatch(setAllAccountCategoryMaster(allAccountCategoriesResponse));
        } else if (allAccountCategoriesResponse.isError) {
            let response: any = allAccountCategoriesResponse.error;
            alertMessage(response, "error");
        }
    }, [allAccountCategoriesResponse.isSuccess, allAccountCategoriesResponse.isError]);


    useEffect(() => {
        if (getAllMemberMasterResponse.isSuccess) {
            dispatch(setMemberMasterList(getAllMemberMasterResponse));
        } else if (getAllMemberMasterResponse.isError) {
            let response: any = getAllMemberMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllMemberMasterResponse.isSuccess, getAllMemberMasterResponse.isError]);

    useEffect(() => {
        if (getAllOrganizationMasterResponse.isSuccess) {
            dispatch(setAllOrganizationMaster(getAllOrganizationMasterResponse));
        } else if (getAllOrganizationMasterResponse.isError) {
            let response: any = getAllOrganizationMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllOrganizationMasterResponse.isSuccess, getAllOrganizationMasterResponse.isError]);


    useEffect(() => {
        if (getAllAccountTypeMasterResponse.isSuccess) {
            dispatch(setAllAccountTypeMaster(getAllAccountTypeMasterResponse));
        } else if (getAllAccountTypeMasterResponse.isError) {
            let response: any = getAllAccountTypeMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAccountTypeMasterResponse.isSuccess, getAllAccountTypeMasterResponse.isError]);


    // upload xlsx...............................
    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };


    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.MEMBER_MASTER) {
                bulkSaveMemberMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) {
                bulkSaveMemberCategoryMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_MASTER) {
                bulkSaveAccountMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) {
                bulkSaveAccountCategoryMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }
            else if (props.reportName === REPORT_NAME.SCENARIO_MASTER) {
                bulkSaveScenarioMasters({
                    payload: formData,
                    token: localUserObj?.token
                })
            }

            else if (props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) {
                bulkSaveScripturalReferencesMasters({
                    payload: formData,
                    token: localUserObj?.token
                })
            }

            else if (props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) {
                bulkSaveAccountTypeMasterMasters({
                    payload: formData,
                    token: localUserObj?.token
                })
            }

        }
    }

    useEffect(() => {
        if (bulkSaveMemberMasterResponse.isSuccess) {
            const response: any = bulkSaveMemberMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.MEMBER_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Member master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveMemberMasterResponse.isError) {
            let response: any = bulkSaveMemberMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveMemberMasterResponse.isSuccess, bulkSaveMemberMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveMemberCategoryMasterResponse.isSuccess) {
            const response: any = bulkSaveMemberCategoryMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.MEMBER_CATEGORY_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Member category master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveMemberCategoryMasterResponse.isError) {
            let response: any = bulkSaveMemberCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveMemberCategoryMasterResponse.isSuccess, bulkSaveMemberCategoryMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveAccountMasterResponse.isSuccess) {
            const response: any = bulkSaveAccountMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.ACCOUNT_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Account master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveAccountMasterResponse.isError) {
            let response: any = bulkSaveAccountMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveAccountMasterResponse.isSuccess, bulkSaveAccountMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveAccountCategoryMasterResponse.isSuccess) {
            const response: any = bulkSaveAccountCategoryMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.ACCOUNT_CATEGORY_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Account category master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveAccountCategoryMasterResponse.isError) {
            let response: any = bulkSaveAccountCategoryMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveAccountCategoryMasterResponse.isSuccess, bulkSaveAccountCategoryMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveScripturalReferencesMastersResponse.isSuccess) {
            const response: any = bulkSaveScripturalReferencesMastersResponse.data;
            const payload = {
                tableName: REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Scriptural Reference Master(s) added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveScripturalReferencesMastersResponse.isError) {
            let response: any = bulkSaveScripturalReferencesMastersResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveScripturalReferencesMastersResponse.isSuccess, bulkSaveScripturalReferencesMastersResponse.isError]);

    useEffect(() => {
        if (bulkSaveScenarioMastersResponse.isSuccess) {
            const response: any = bulkSaveScenarioMastersResponse.data;
            const payload = {
                tableName: REPORT_NAME.SCENARIO_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Scenario Reference Master(s) added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveScenarioMastersResponse.isError) {
            let response: any = bulkSaveScenarioMastersResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveScenarioMastersResponse.isSuccess, bulkSaveScenarioMastersResponse.isError]);


    useEffect(() => {
        if (bulkSaveAccountTypeMasterMastersResponse.isSuccess) {
            const response: any = bulkSaveAccountTypeMasterMastersResponse.data;
            const payload = {
                tableName: REPORT_NAME.ACCOUNT_TYPE_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Account Type Master(s) added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveAccountTypeMasterMastersResponse.isError) {
            let response: any = bulkSaveAccountTypeMasterMastersResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveAccountTypeMasterMastersResponse.isSuccess, bulkSaveAccountTypeMasterMastersResponse.isError]);



    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // dialogClassName={"modal-90w"}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" } // default to lg for all others
                )}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-accent" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        saveMemberMasterResponse.isLoading ||
                            saveMemberCategoryMasterResponse.isLoading ||
                            bulkSaveMemberMasterResponse.isLoading ||
                            bulkSaveMemberCategoryMasterResponse.isLoading ||
                            saveAccountMasterResponse.isLoading ||
                            saveAccountCategoryMasterResponse.isLoading ||
                            bulkSaveAccountMasterResponse.isLoading ||
                            bulkSaveAccountCategoryMasterResponse.isLoading ||
                            updateMemberMasterResponse.isLoading ||
                            updateMemberCategoryMasterResponse.isLoading ||
                            updateAccountMasterResponse.isLoading ||
                            updateAccountCategoryMasterResponse.isLoading ||
                            memberMasterByIdResponse.isLoading ||
                            memberCategoryMasterByIdResponse.isLoading ||
                            accountMasterByIdResponse.isLoading ||
                            accountCategoryMasterByIdResponse.isLoading ||
                            allMemberCategoriesResponse.isLoading ||
                            allAccountCategoriesResponse.isLoading ||
                            saveScenarioMasterResponse.isLoading ||
                            bulkSaveScenarioMastersResponse.isLoading ||
                            updateScenarioMasterResponse.isLoading ||
                            scenarioMasterByIdResponse.isLoading ||
                            saveScripturalReferenceMasterResponse.isLoading ||
                            bulkSaveScripturalReferencesMastersResponse.isLoading ||
                            updateScripturalReferenceMasterResponse.isLoading ||
                            scripturalReferenceMasterByIdResponse.isLoading ||
                            saveAccountTypeMasterResponse.isLoading ||
                            bulkSaveAccountTypeMasterMastersResponse.isLoading ||
                            updateAccountTypeMasterMasterResponse.isLoading ||
                            accountTypeMasterByIdResponse.isLoading ? (

                            < Loading />
                        ) : (
                            ""
                        )}

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}
                    {/* {props.actionType === ACTION_TYPE.ADD_ACTION && activeTab === 'bulk' && (
                        <div className="mb-3">
                            <Link
                                to="/member-accounting-report/bulk-upload"
                                className="btn btn-primary"
                            >
                                Download Template
                            </Link>
                            <input
                                type="file"
                                className="form-control mt-2"
                                onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                        setFile(e.target.files[0]);
                                        setFileName(e.target.files[0].name);
                                    }
                                }}
                            />
                        </div>
                    )} */}
                    {activeTab === "manual" && (
                        <Formik
                            enableReinitialize={true}
                            initialValues={(props.reportName === REPORT_NAME.MEMBER_MASTER) ? {
                                memberName: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.memberName
                                    : "",
                                memberCategoryCode: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.memberCategoryCode
                                    : "",
                                orgCode: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.orgCode
                                    : "",
                                gender: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.gender
                                    : "",
                                dob: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.dob
                                    : "",
                                contactInfo: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.contactInfo
                                    : "",
                                dependentMemberId: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.dependentMemberId
                                    : "",
                            } : (props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER) ? {
                                memberCategoryName: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.memberCategoryName
                                    : "",
                                description: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.description
                                    : "",
                            } : (props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER) ? {
                                accountCategoryName: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.accountCategoryName
                                    : "",
                                description: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.description
                                    : "",
                                dependentAccountCategoryCode: ACTION_TYPE.UPDATE_ACTION
                                    ? getByIdData && getByIdData.dependentAccountCategoryCode
                                    : "",
                                accountTypeId: ACTION_TYPE.UPDATE_ACTION ? getByIdData && getByIdData.accountTypeId : ""
                            } : (props.reportName === REPORT_NAME.SCENARIO_MASTER) ? {
                                memberId: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.memberId : "",
                                scenarioType: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.scenarioType : "",
                                description: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.description : "",
                                religion: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.religion : "",
                                projectTag: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.projectTag : "",
                                intensityLevel: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.intensityLevel : "",
                            } : (props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER) ? {
                                religion: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.religion : "",
                                textSnippet: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.textSnippet : "",
                                context: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.context : "",
                                application: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.application : "",
                            } : (props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER) ? {
                                id: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id : 0,
                                accountTypeCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountCode : "",
                                accountTypeName: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountName : "",
                                accountTypeDescription: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountDescription : "",
                                isActive: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive : true,
                            } : {
                                accountCategoryCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountCategoryCode : "",
                                accountName: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountName : "",
                                description: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.description : "",
                                dependentAccountCode: ACTION_TYPE.UPDATE_ACTION ? getByIdData?.dependentAccountCode : "",
                            }
                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, handleChange, setFieldValue, errors }) => (
                                <Form>
                                    {props.reportName === REPORT_NAME.MEMBER_MASTER ? (
                                        <div>

                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div> {props.reportName} Name</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.memberName}
                                                    name="memberName"
                                                    required
                                                />
                                            </div>
                                            <div className="w-100 mt-2">
                                                <div className="d-flex">
                                                    <div>
                                                        Select Member Category
                                                    </div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <div className="pe-2">

                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="memberCategoryCode"
                                                        value={values.memberCategoryCode}
                                                        onChange={(e) => setFieldValue("memberCategoryCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Voucher Type</option>
                                                        {allMemberCategoriesData && allMemberCategoriesData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.memberCategoryName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Gender</div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="gender"
                                                        value={values.gender}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="" disabled>
                                                            Select Gender
                                                        </option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Date of Birth</div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>

                                                    <DatePicker
                                                        className="w-100"
                                                        format="YYYY-MM-DD"
                                                        required
                                                        value={values.dob ? dayjs(values.dob, "YYYY-MM-DD") : null}
                                                        onChange={(date) =>
                                                            setFieldValue("dob", date ? date.format("YYYY-MM-DD") : "")
                                                        }
                                                        getPopupContainer={(trigger) =>
                                                            (trigger.parentNode as HTMLElement) || document.body
                                                        }
                                                    />
                                                </div>

                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Contact Info</div>

                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.contactInfo}
                                                        name="contactInfo"
                                                    // required
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <label className="form-label">
                                                        Dependent Member ID
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="dependentMemberId"
                                                        value={values.dependentMemberId}
                                                        onChange={(e) => setFieldValue("dependentMemberId", e.target.value)}
                                                    >
                                                        <option value="">Select Dependent Member</option>
                                                        {allMemberMastersData &&
                                                            allMemberMastersData.map((item: any, idx: number) => (
                                                                <option key={idx} value={item.id}>
                                                                    {item.id} - {item.memberName}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>

                                            </div>
                                            <div className="mt-2">
                                                <label className="form-label">
                                                    Org Code
                                                </label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    name="orgCode"
                                                    value={values.orgCode}
                                                    required
                                                    onChange={(e) => setFieldValue("orgCode", e.target.value)}
                                                >
                                                    <option value="">Select Organization</option>
                                                    {allOrganizationMasterData?.map((org: any, idx: number) => (
                                                        <option key={idx} value={org.id}>
                                                            {org.id} - {org.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    ) : props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER ? (
                                        <div>
                                            <div>
                                                <div className="d-flex">
                                                    <div> {props.reportName} Name</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.memberCategoryName}
                                                    name="memberCategoryName"
                                                    required
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Description</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.description}
                                                    name="description"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    ) : props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER ? (
                                        <div className="">
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Account Category Name</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.accountCategoryName}
                                                    name="accountCategoryName"
                                                    required
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Select Account Type</div>
                                                </div>
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"

                                                    onChange={(e) => setFieldValue("accountTypeId", e.target.value)}
                                                    name="accountTypeId"
                                                    value={values.accountTypeId}

                                                >
                                                    <option value="">
                                                        Select Account Type
                                                    </option>
                                                    {allAccountTypeMasterData &&
                                                        allAccountTypeMasterData.map((itemType: any, index: any) => {
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.id}
                                                                >
                                                                    {itemType.id} - {itemType.accountName}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Description</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.description}
                                                    name="description"
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Dependent Account Category Code</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.dependentAccountCategoryCode}
                                                    name="dependentAccountCategoryCode"
                                                />
                                            </div>
                                        </div>
                                    ) : props.reportName === REPORT_NAME.SCENARIO_MASTER ? (
                                        <div className="w-100">
                                            {/* Member ID Dropdown */}
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Member</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    name="memberId"
                                                    value={values.memberId}
                                                    onChange={(e) => setFieldValue("memberId", e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Member</option>
                                                    {allMemberMastersData &&
                                                        allMemberMastersData.map((item: any, index: number) => (
                                                            <option key={index} value={item.id}>
                                                                {item.id} - {item.memberName}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>

                                            {/* Scenario Type */}
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Scenario Type</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="scenarioType"
                                                    onChange={handleChange}
                                                    value={values.scenarioType}
                                                    required
                                                />
                                            </div>

                                            {/* Description */}
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Description</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    name="description"
                                                    onChange={handleChange}
                                                    value={values.description}
                                                    required
                                                />
                                            </div>

                                            {/* Religion */}
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Religion</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="religion"
                                                    onChange={handleChange}
                                                    value={values.religion}
                                                    required
                                                />
                                            </div>

                                            {/* Project Tag */}
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Project Tag</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="projectTag"
                                                    onChange={handleChange}
                                                    value={values.projectTag}
                                                    required
                                                />
                                            </div>

                                            {/* Intensity Level */}
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Intensity Level</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="intensityLevel"
                                                    onChange={handleChange}
                                                    value={values.intensityLevel}
                                                    required
                                                />
                                            </div>
                                        </div>

                                    ) : props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER ? (
                                        <div className="w-100">
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Religion</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="religion"
                                                    onChange={handleChange}
                                                    value={values.religion}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Text Snippet</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    name="textSnippet"
                                                    onChange={handleChange}
                                                    value={values.textSnippet}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Context</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    name="context"
                                                    onChange={handleChange}
                                                    value={values.context}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Application</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    name="application"
                                                    onChange={handleChange}
                                                    value={values.application}
                                                    required
                                                />
                                            </div>
                                        </div>

                                    ) : props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER ? (
                                        <div>
                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Account Type Code</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="accountTypeCode"
                                                    value={values.accountTypeCode}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Account Type Name</div>
                                                    <div style={{ color: "red" }}>*</div>
                                                </div>
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    name="accountTypeName"
                                                    value={values.accountTypeName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-2">
                                                <div className="d-flex">
                                                    <div>Description</div>
                                                </div>
                                                <textarea
                                                    className="form-control form-control-sm w-100"
                                                    name="accountTypeDescription"
                                                    value={values.accountTypeDescription}
                                                    onChange={handleChange}
                                                    rows={3}
                                                />
                                            </div>

                                        </div>
                                    )
                                        : (
                                            <div className="">
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Account Name</div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.accountName}
                                                        name="accountName"
                                                        required
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Description</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.description}
                                                        name="description"
                                                        required
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Select Account Category Code</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"

                                                        onChange={(e) => setFieldValue("accountCategoryCode", e.target.value)}
                                                        name="accountCategoryCode"
                                                        value={values.accountCategoryCode}
                                                        required

                                                    >
                                                        <option value="">
                                                            Select Account Category
                                                        </option>
                                                        {allAccountCategoriesData &&
                                                            allAccountCategoriesData.map((itemType: any, index: any) => {
                                                                return (
                                                                    <option
                                                                        key={index.toString()}
                                                                        value={itemType.id}
                                                                    >
                                                                        {itemType.id} - {itemType.accountCategoryName}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                                <div className="mt-2">
                                                    <div className="d-flex">
                                                        <div>Dependent Account Code</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.dependentAccountCode}
                                                        name="dependentAccountCode"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                    < div className="d-flex flex-row justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                        >
                                            {props.actionType === ACTION_TYPE.ADD_ACTION
                                                ? "Save"
                                                : "Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.MEMBER_MASTER ? 'MEMBER_MASTER' :
                                        props.reportName === REPORT_NAME.MEMBER_CATEGORY_MASTER ? 'MEMBER_CATEGORY_MASTER' :
                                            props.reportName === REPORT_NAME.ACCOUNT_MASTER ? 'ACCOUNT_MASTER' :
                                                props.reportName === REPORT_NAME.ACCOUNT_CATEGORY_MASTER ? 'ACCOUNT_CATEGORY_MASTER' :
                                                    props.reportName === REPORT_NAME.SCENARIO_MASTER ? 'SCENARIO_MASTER' :
                                                        props.reportName === REPORT_NAME.SCRIPTURAL_REFERENCE_MASTER ? 'SCRIPTURAL_REFERENCE_MASTER' :
                                                            props.reportName === REPORT_NAME.ACCOUNT_TYPE_MASTER ? 'ACCOUNT_TYPE_MASTER' :
                                                                ''
                                    }.xlsx`}

                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );

};

export default MemberAccountingReportData